import { Phone, Mail } from "lucide-react";
import { RichText } from "./RichText";
import { ChatCards } from "./ChatCards";

const Typing = () => (
  <div className="flex gap-1 py-1" data-testid="chat-typing-indicator" aria-label="Assistant is typing">
    {[0, 1, 2].map((i) => <span key={i} className="w-2 h-2 rounded-full bg-slate-400 animate-bounce" style={{ animationDelay: `${i * 0.15}s` }} />)}
  </div>
);

export const ContactButtons = ({ b, testid }) => (
  <div className="flex gap-2 mt-2" data-testid={testid}>
    <a href={`tel:${b.phone_tel}`} className="btn-amber h-8 px-3 text-[11px]"><Phone className="w-3.5 h-3.5" />Call</a>
    <a href={`mailto:${b.email}`} className="btn-ghost h-8 px-3 text-[11px]"><Mail className="w-3.5 h-3.5" />Email</a>
  </div>
);

export const Bubble = ({ m, b, onNavigate, index }) => {
  const user = m.role === "user";
  return (
    <div className={`flex ${user ? "justify-end" : "justify-start"}`} data-testid={`chat-message-${index}`} data-role={m.role}>
      <div className={`max-w-[88%] space-y-2 ${user ? "" : "w-full"}`}>
        {!user && m.cards?.length > 0 && <ChatCards cards={m.cards} onNavigate={onNavigate} />}
        {(m.content || m.pending || m.error) && (
          <div className={`px-3.5 py-2.5 text-sm leading-relaxed ${user ? "bg-brand-600 text-white" : m.error ? "bg-red-50 border border-red-200 text-slate-800" : "bg-white border border-slate-200 text-slate-700"}`}>
            {m.pending && !m.content ? <Typing /> : user ? <p className="whitespace-pre-wrap">{m.content}</p> : <RichText text={m.content} onNavigate={onNavigate} />}
            {m.error && <ContactButtons b={b} testid="chat-fallback-actions" />}
          </div>
        )}
      </div>
    </div>
  );
};
